import state from './moduleIntegrationsState.js';
import mutations from './moduleIntegrationsMutations.js';
import actions from './moduleIntegrationsActions.js';
import getters from './moduleIntegrationsGetters.js';

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
